export const Home = () => (
  <path d='M19,23H5c-1.7,0-3-1.3-3-3V9c0-0.3,0.1-0.6,0.4-0.8l9-7c0.4-0.3,0.9-0.3,1.2,0l9,7C21.9,8.4,22,8.7,22,9v11C22,21.7,20.7,23,19,23z M16,21h3c0.6,0,1-0.4,1-1V9.5l-8-6.2L4,9.5V20c0,0.6,0.4,1,1,1h3v-9c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1c0,0,0,0,0,0V21z M10,21h4v-8h-4L10,21z' />
)
